import React, { useContext } from "react";
import MedicalServicesOutlinedIcon from "@mui/icons-material/MedicalServicesOutlined";

import { ConfiguracionContext } from "../../../../context/ConfiguracionContext";
import MaestroArchivo from "../../common/MaestroArchivo";

export default function TiposServicios() {
  const {
    tiposServicios,
    obtenerTiposServicios,
    agregarTipoServicio,
    actualizarTipoServicio,
  } = useContext(ConfiguracionContext);

  return (
    <MaestroArchivo
      titulo="Tipos de Servicios"
      entidad="tipo de servicio"
      layout="TiposServicios"
      icono={<MedicalServicesOutlinedIcon />}
      items={tiposServicios}
      onObtener={() => obtenerTiposServicios({ todos: true })}
      onAgregar={(data) => agregarTipoServicio({ tipoServicio: data })}
      onActualizar={(data) => actualizarTipoServicio({ tipoServicio: data })}
    />
  );
}
